import axios from "axios";
import type { AxiosInstance, AxiosResponse, InternalAxiosRequestConfig } from "axios";

const api: AxiosInstance = axios.create({
  baseURL: process.env.VUE_APP_API_URL ?? "https://snddeback.yarkoapp.com/api",
  timeout: 10000,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

api.interceptors.request.use((config: InternalAxiosRequestConfig) => {
  // Seul /public/ ne nécessite pas d'authentification
  const isPublicEndpoint = config.url?.includes("/public/");

  const token = localStorage.getItem("token");
  if (token && config.headers && !isPublicEndpoint) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response: AxiosResponse) => response,
  async (error) => {
    const originalRequest = error.config;
    const url = originalRequest?.url ?? "";
    // Ne pas tenter de refresh pour les endpoints d'auth ou publics
    const skipRefresh = url.includes("/public/") || url.includes("/auth/login") || url.includes("/auth/refresh");

    const hasToken = !!localStorage.getItem("token");

    if (error.response?.status === 401 && !originalRequest._retry && !skipRefresh && hasToken) {
      originalRequest._retry = true;
      try {
        const { data } = await api.post("/auth/refresh");
        localStorage.setItem("token", data.token);
        originalRequest.headers.Authorization = `Bearer ${data.token}`;
        return api.request(originalRequest);
      } catch {
        localStorage.clear();
        window.location.href = "/dde/login";
      }
    }

    return Promise.reject(error);
  }
);

export default api;
